var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"input",attrs:{"value":_vm.displayValue,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"size":_vm.size,"max":_vm.max,"min":_vm.min},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"input":_vm.handleInput,"change":_vm.handleInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }